import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';

const borderColor = 'rgba(219, 223, 241, 1)';
const selectedRowBackground = '#EEF8F2';

const tableStyle = {
  rows: {
    style: {
      minHeight: '44px', // override the row height
      fontSize: '1rem',
      color: AppColors.gray[700],
      // backgroundColor: 'red',
      paddingLeft: '0px',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${borderColor}`,
      },
      '&:last-of-type': {
        borderBottom: `1px solid ${borderColor}`,
      },
    },
    selectedHighlightStyle: {
      '&:nth-of-type(n)': {
        color: AppColors.gray[700],
        backgroundColor: 'transparent',
        borderBottomColor: borderColor,
        '& .rdt_TableCell': {
          backgroundColor: selectedRowBackground,
        },
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F3F6F9',
    },
  },
  headRow: {
    style: {
      borderBottomColor: borderColor,
      backgroundColor: 'rgba(249, 249, 249, 1)',
    },
  },
  cells: {
    style: {
      // paddingLeft: "0px", // override the cell padding for data cells
      // paddingRight: "1rem",
      // marginLeft: 'px',
      padding: '0rem 1rem',
      '& input[type="checkbox"]': {
        accentColor: AppColors.primary,
      },
      '&:first-of-type': {
        // borderLeft: `1px solid ${borderColor}`,
      },
      // borderRight: `1px solid ${borderColor}`,
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${borderColor}`,
      },
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 600,
      paddingLeft: '0px',
      paddingRight: '0px',
      color: AppColors.gray[700],
      '& input[type="checkbox"]': {
        accentColor: AppColors.primary,
      },
      // textTransform: 'uppercase',
      letterSpacing: '0.1rem',
      lineHeight: '1.5 !important',
      padding: '0.5rem 1rem',
      // borderRight: `1px solid ${borderColor}`,
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${borderColor}`,
      },
      borderTop: `1px solid ${borderColor}`,
      '&:first-of-type': {
        // borderLeft: `1px solid ${borderColor}`,
      },
    },
    activeSortStyle: {
      '&:focus': {
        outline: 'none',
        color: '#3699FF',
      },
      '&:not(focus)': {
        color: '#3699FF',
      },
      '&:hover:not(:focus)': {
        color: '#3699FF',
      },
    },
    inactiveSortStyle: {
      '&:focus': {
        outline: 'none',
        color: '#B5B5C3',
      },
      '&:hover': {
        color: '#3699FF',
      },
    },
  },

  columns: {
    normal: {
      color: AppColors.gray[700],
      fontWeight: '500',
      fontSize: '13px',
      width: '100%',
    },
    link: {
      color: AppColors.primary,
      fontWeight: '600',
      fontSize: '13px',
    },
    textLink: {
      color: '#30BD6F',
      fontWeight: '600',
      fontSize: Utils.convertToFontSize(13),
    },
    danger: {
      color: '#E14E54',
      fontWeight: '600',
    },
  },
};

export default tableStyle;
